<script>
	// Shared tabs controller for slot-based listing sections.
	export default {

	props: {
		heading: {
			type: String,
			default: 'Listings'
		},
	},
	emits: ['switch'],
	data () {
		return {
			selectedId: null,
			tabs: []
		}
	},
	provide () {
		return {
			tabsApi: {
				register: tab => this.registerTab(tab),
				update: (id, updates) => this.updateTab(id, updates),
				unregister: tab => this.unregisterTab(tab),
			}
		}
	},
	mounted () {
		this.ensureSelectedTab()
	},
	updated () {
		this.ensureSelectedTab()
	},
	methods: {
		registerTab (tab) {
			if (!this.tabs.some(item => item.id === tab.id)) {
				this.tabs.push(tab)
				this.ensureSelectedTab()
			}
		},
		updateTab (id, updates) {
			const index = this.tabs.findIndex(tab => tab.id === id)
			if (index === -1) {
				return
			}

			this.tabs.splice(index, 1, {
				...this.tabs[index],
				...updates,
			})

			this.ensureSelectedTab()
		},
		unregisterTab (id) {
			const wasSelected = this.selectedId === id

			this.tabs = this.tabs.filter(item => item.id !== id)

			if (wasSelected) {
				this.selectedId = null
			}

			this.ensureSelectedTab()
		},
		selectFirstEnabled () {
			const index = this.tabs.findIndex(tab => !tab.disabled)
			if (index !== -1) {
				this.selectTab(index)
			}
		},
		ensureSelectedTab () {
			const selectedTab = this.tabs.find(tab => tab.id === this.selectedId)

			// Async listing loads can enable/disable tabs after registration; keep selection on the first enabled tab.
			if (!selectedTab || selectedTab.disabled) {
				this.selectFirstEnabled()
				return
			}

			this.tabs.forEach(tab => {
				tab.setActive(tab.id === this.selectedId)
			})
		},
		selectTab (i) {
			const selectedTab = this.tabs[i]
			if (!selectedTab || selectedTab.disabled) {
				return
			}

			this.selectedId = selectedTab.id

			this.tabs.forEach(tab => {
				tab.setActive(tab.id === selectedTab.id)
			});

            this.$emit('switch', selectedTab.title)
		}
	}
}
</script>

<template>
  <div>

	<div class="flex flex-col sm:flex-row items-center sm:items-start px-45">

		<div class="flex-grow">
			<h2>{{ heading }}</h2>
		</div>

		<div class="header__buttons-holder mt-45 sm:mt-0 flex" v-show="tabs.length > 1">
			<button
				v-for="(tab, index) in tabs"
                :disabled="tab.disabled"
				:key="tab.id"
				@click="selectTab(index)"
				class="bg-white header__btn"
				:class='{"active": tab.id === selectedId, "cursor-not-allowed opacity-50": tab.disabled}'
			>
				{{ tab.title }}
			</button>
		</div>

	</div>

	<div class="mt-60 w-full flex-grow">
    	<slot></slot>
	</div>

  </div>
</template>

<style scoped>
	.header--both h2::after{
		left: 28px;
	}
	.header__buttons-holder{
		box-shadow: 0px 4px 20px rgba(51, 72, 82, 0.08);
		border-radius: 2px;
	}
	.header__btn{
		position: relative;
		padding: 28px 28px 30px;
		overflow: hidden;
		color: #64747C;
	}
	.header__btn:not(:first-child){
		border-left: 1px solid #DCDDDF;
	}
	.header__btn::after{
		content: '';
		position: absolute;
		z-index: 1;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 2px;
		background: #5EBC86;

		transform: translateY(100%);
		transition: transform .25s;
	}
	.header__btn.active::after{
		transform: translateY(0);
	}

	.filled-button--arrow::after{
			/* copied styles */
		    font-family: 'Icons';
			font-style: normal;
			font-weight: inherit;
			line-height: 1em;
			width: auto;
			font-variant: normal;
			text-transform: none;
			text-decoration: inherit;
			text-align: center;
			speak: none;
			font-size: inherit;
			content: '\e807';

			padding-left: 15px;
	}
</style>
